export default "__VITE_ASSET__C9CJuZL0__"